import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
  CardHeader,
  MenuItem,
  Menu,
  DialogActions,
  DialogTitle,
  Dialog,
  DialogContent,
  TextField,
  ListItemIcon,
  //   TableSelectRow,
} from "@mui/material";
import {
  DeleteOutline,
  FileDownloadOutlined,
  ModeEditOutlineOutlined,
  MoreVertOutlined,
} from "@mui/icons-material";
import dataProcess from "../../assets/img/data-running.mp4";
import totalImages from "../../assets/icons/Images.svg";
import datasetIcon from "../../assets/icons/datasetIcon.svg";
import withSpinner from "../../HOC/withSpinner";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllModels,
  fetchConfusionMatrix,
  deleteProjectTrainPublishedModel,
  reNameModelByIdPublished,
  publishModel,
  publishModeltoInference,
} from "../../store/slice/ProjectTrainSlice";
import crunching from "../../assets/img/crunching3.mp4";
import { AppDispatch, RootState } from "../../store/store";
import { startSpinner, stopSpinner } from "../../store/slice/UISlice";
import { ProjectModelItem } from "../../types/interface/ProjectTrain.interface";
import { toast } from "react-toastify";
import { fetchProjects } from "../../store/slice/projectHandler";
import ConfusisonMetrixPNG from "../../assets/img/confusion_matrix.png";
import PCurvePNG from "../../assets/img/P_curve.png";
import RCurvePNG from "../../assets/img/R_curve.png";
import ResultPNG from "../../assets/img/results.png";
import LoaderGIF from "../../assets/img/loader.gif";
import { downloadTest } from "../../store/slice/ProjectTestSlice";
import { AxiosProgressEvent } from "axios";
import { ProjectItem } from "../../types/interface";
import ConfusionMatrix from "./confusionMatrix";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import CloseIcon from "@mui/icons-material/Close";
import ConfusionMatrixIframe from "../Train/ConfusionMatrixIframe";
import AuthenticatedReportImage from "../Train/AuthenticatedReportImage";
import finalResult from "../../assets/img/final.mp4";

// Define types for the data
interface RowData {
  id: string;
  name: string;
  project: string;
  date: string;
  type: string;
  member: string;
  details: string;
}

export interface ProjectDataItem {
  id: string;
  labels: number;
  images: number;
  annotations: number;
  annotatedImageCount: number;
  models: number;
  imageUrl: string;
  thubmImageUrl: string;
  name: string;
  description: string;
  taskTypeId: string;
  domainTypeId: string;
  createdDate: string;
  customerId: string;
  liked: boolean;
  colour: string;
}

const Model: React.FC = () => {
  const [open, setOpen] = useState<string | null>(null);
  const [models, setModels] = useState<ProjectModelItem[]>([]);
  const [projectDetails, setProjectDetails] = useState<ProjectItem | null>(
    null
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModelModal, setOpenEditModelModal] = useState(false);
  const [currentId, setCurrentId] = useState<string | null>(null);
  const [currentName, setCurrentName] = useState<string | null | undefined>(
    null
  );
  const [currentProId, setcurrentProId] = useState<string | null>(null);
  const [modelName, setModelName] = useState(currentName || "");
  const [currentConfusisonMetrixPNG, setCurrentConfusisonMetrixPNG] =
    useState(ConfusisonMetrixPNG);
  const [currentResultPNG, setCurrentResultPNG] = useState(ResultPNG);
  const [currentPCurvePNG, setCurrentPCurvePNG] = useState(PCurvePNG);
  const [currentRCurvePNG, setCurrentRCurvePNG] = useState(RCurvePNG);
  const [statusCMImg, setStatusCMImg] = useState<boolean | null>(null);
  const [statusRImg, setStatusRImg] = useState<boolean | null>(null);
  const [statusPCImg, setStatusPCImg] = useState<boolean | null>(null);
  const [statusRCImg, setStatusRCImg] = useState<boolean | null>(null);

  const [downloadingIds, setDownloadingIds] = useState<string[]>([]);
  const [modelType, setModelType] = useState<string | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setModelName(event.target.value);
  };

  const handleDeleteModel = (Id: string, Name: string | undefined) => {
    setCurrentId(Id);
    setCurrentName(Name);
    setOpenDeleteModal(true);
    localStorage.setItem("popupOpen", true.toString());
    handleClose();
  };

  const handleCloseDeleteModal = () => {
    setCurrentId(null);
    setCurrentName(null);
    setOpenDeleteModal(false);
    localStorage.setItem("popupOpen", false.toString());
  };

  const handleConfirmDelete = () => {
    console.log(currentId);
    if (currentId != null) {
      dispatch(deleteProjectTrainPublishedModel(currentId)) // Dispatch delete action with the provided idss
        .unwrap() // Unwrap the promise to handle success or failure
        .then(() => {
          setCurrentId(null);
          setCurrentName(null);
          setOpenDeleteModal(false);
          localStorage.setItem("popupOpen", false.toString());
          toast.success("Model deleted successfully!");
          try {
            dispatch(fetchAllModels());
          } catch (error) {
            toast.error("Failed to fetch models");
          } finally {
            dispatch(stopSpinner());
          }
        })
        .catch((error) => {
          const errorMessage =
            error?.message || error || "Failed to delete model. Try again.";
          toast.error(errorMessage);
          setOpenDeleteModal(false);
          localStorage.setItem("popupOpen", false.toString());
        });
    }
  };

  const handleModelRename = (
    id: string,
    name: string | undefined,
    proId: string
  ) => {
    console.log(name);
    setCurrentId(id);
    setCurrentName(name);
    setcurrentProId(proId);
    setOpenEditModelModal(true);
    localStorage.setItem("popupOpen", true.toString());
    handleClose();
  };

  const handleRenameModelClose = () => {
    setOpenEditModelModal(false);
    localStorage.setItem("popupOpen", false.toString());
    setCurrentId(null);
    setCurrentName(null);
    setcurrentProId(null);
  };

  const handleRenameModelSave = () => {
    // Validation for modelName length
    if (!modelName || modelName.trim().length < 3) {
      toast.error("Model name must be at least 3 characters long");
      return;
    }

    if (currentId && modelName) {
      dispatch(
        reNameModelByIdPublished({ id: currentId, TrainingName: modelName })
      )
        .unwrap()
        .then(() => {
          setOpenEditModelModal(false); // Close modal
          localStorage.setItem("popupOpen", false.toString());
          toast.success("Model Name Updated");

          try {
            dispatch(fetchAllModels()); // Refresh models list
          } catch (error) {
            toast.error("Failed to fetch models");
          } finally {
            dispatch(stopSpinner());
          }
        })
        .catch((error) => {
          // Ensure proper error message display
          const errorMsg =
            error?.message || "An error occurred while updating the model.";
          toast.error(errorMsg);
        });
    }
    // Reset state after save
    setOpenEditModelModal(false);
    localStorage.setItem("popupOpen", false.toString());
    setCurrentId(null);
    setCurrentName(null);
    setcurrentProId(null);
  };

  const [selectedModel, setSelectedModel] =
    React.useState<ProjectModelItem | null>(null);

  const open1 = Boolean(anchorEl);
  const handleMoreOptionClick = (
    event: React.MouseEvent<HTMLElement>,
    optionId: string
  ) => {
    setAnchorEl(event.currentTarget);
    const model = models.find((model) => model.id === optionId) || null; // Default to null if undefined
    setSelectedModel(model);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedModel(null); // Reset selected model
  };

  const { allModels } = useSelector((state: RootState) => state.projectTrain);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval>;
    let firstLoad = true;

    const fetchAllModelsThrottled = async () => {
      try {
        if (firstLoad) {
          dispatch(startSpinner("Fetching Models"));
        }
        await dispatch(fetchAllModels()).unwrap();
      } catch (error) {
        toast.error("Failed to fetch models");
      } finally {
        if (firstLoad) {
          dispatch(stopSpinner());
          firstLoad = false;
        }
      }
    };

    // Run immediately first
    fetchAllModelsThrottled();

    // Run every 2 seconds (without spinner)
    intervalId = setInterval(fetchAllModelsThrottled, 5000);

    return () => {
      clearInterval(intervalId);
      dispatch(stopSpinner());
    };
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(allModels)) {
      setModels(allModels);
    }
  }, [allModels]);

  const handleToggle = async (
    id: string,
    projectId: string,
    modelType: string,
    trainingId: string
  ) => {
    setOpen(open === id ? null : id);

    if (open == null || open !== id) {
      setProjectDetails(null);
      dispatch(startSpinner(""));

      // Reset placeholders
      setCurrentConfusisonMetrixPNG(LoaderGIF);
      setCurrentResultPNG(LoaderGIF);
      setCurrentPCurvePNG(LoaderGIF);
      setCurrentRCurvePNG(LoaderGIF);
      setStatusCMImg(null);
      setStatusRImg(null);
      setStatusPCImg(null);
      setStatusRCImg(null);

      try {
        const fetchProjectsPromise = dispatch(fetchProjects()).unwrap();

        const imageUrlsPromise = Promise.resolve().then(() => {
          const train_id = trainingId;
          return {
            cm: `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${train_id}&imgName=confusion_matrix.html`,
            result: `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${train_id}&imgName=graph_1.html`,
            pcurve: `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${train_id}&imgName=graph_2.html`,
            rcurve: `${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${train_id}&imgName=results_comparison.png`,
          };
        });

        // Run in parallel
        const [projects, imageUrls] = await Promise.all([
          fetchProjectsPromise,
          imageUrlsPromise,
        ]);

        // Handle projects
        const project = projects.find((item: any) => item.id === projectId);
        if (project) {
          setProjectDetails(project);
        }

        // Handle images
        setCurrentConfusisonMetrixPNG(imageUrls.cm);
        setCurrentResultPNG(imageUrls.result);
        setCurrentPCurvePNG(imageUrls.pcurve);
        setCurrentRCurvePNG(imageUrls.rcurve);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        dispatch(stopSpinner());
      }
    }
  };
  const formatDate = (isoString: string): string => {
    const date = new Date(isoString); // Convert ISO string to Date object
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date); // Format the date
  };

  const handleDownload = async (trainingId: string) => {
    if (!trainingId) {
      // Handle the case where the trainingId is null (optional)
      console.error("No trainingId provided!");
      return;
    }

    setDownloadingIds((prev) => [...prev, trainingId]); // Add the new ID to the array

    const resultAction = await dispatch(
      downloadTest({
        trainingId,
        options: {
          onDownloadProgress: (progressEvent: AxiosProgressEvent) => {
            // Specify the type here
            const total = progressEvent.total || 0;
            const current = progressEvent.loaded || 0;
            const percentage = Math.floor((current / total) * 100);
          },
        },
      })
    );

    // Remove ID from downloadingIds once the download completes
    setDownloadingIds((prev) => prev.filter((id) => id !== trainingId));

    if (downloadTest.fulfilled.match(resultAction)) {
      handleClose();
      toast.success(`Download completed`, {
        position: "bottom-right",
      });
    } else {
      toast.error(resultAction.error.message as string, {
        position: "bottom-right",
      });
    }
  };

  const [openConfusionMatrix, setOpenConfusionMatrix] = useState(false);
  const handleOpenConfusionMatrix = () => {
    setOpenConfusionMatrix(true);
    localStorage.setItem("popupOpen", true.toString());
  };
  const handleCloseConfusionMatrix = () => {
    setOpenConfusionMatrix(false);
    localStorage.setItem("popupOpen", false.toString());
  };

  const handlePublishToAIAssist = (idMod: string) => {
    dispatch(publishModel(idMod))
      .unwrap()
      .then((response) => {
        toast.success("Model Published Successfully");
      })
      .catch((error) => {
        toast.error(error);
      });
  };

    const handlePublishToInference = (idMod: string) => {
    dispatch(publishModeltoInference(idMod))
      .unwrap()
      .then((response) => {
        toast.success("Model Published Successfully");
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  return (
    <>
      <Box sx={{ background: "#F5F6F9" }}>
        <Box sx={{ margin: "20px" }}>
          <Box
            sx={{ boxShadow: "0px 0px 5px 0px #0000003", background: "white" }}
          >
            <Box
              sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  padding: "10px",
                  color: "#49454F",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Models List
              </Typography>
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: "calc(100vh - 180px)",
                overflow: "auto", // allows scroll
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE/Edge
                "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari
              }}
            >
              <Table
                sx={{ paddingLeft: "10px" }}
                aria-label="collapsible sticky table"
                stickyHeader
              >
                <TableHead
                  sx={{
                    background: "#E1EDFB",
                    position: "relative",
                    zIndex: "20",
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        padding: "4px",
                        color: "#6E6893",
                        textTransform: "uppercase",
                        background: "#E1EDFB",
                      }}
                    >
                      Model Name
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "4px",
                        color: "#6E6893",
                        textTransform: "uppercase",
                        background: "#E1EDFB",
                      }}
                    >
                      Project
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "4px",
                        color: "#6E6893",
                        textTransform: "uppercase",
                        background: "#E1EDFB",
                      }}
                    >
                      Date
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "4px",
                        color: "#6E6893",
                        textTransform: "uppercase",
                        background: "#E1EDFB",
                      }}
                    >
                      Task
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: "4px",
                        color: "#6E6893",
                        textTransform: "uppercase",
                        background: "#E1EDFB",
                      }}
                    >
                      Size
                    </TableCell>
                    <TableCell sx={{ background: "#E1EDFB" }} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {models.length > 0 ? (
                    models.map((model) => (
                      <React.Fragment key={model.id}>
                        <TableRow
                          id="modelViewDetail"
                          sx={{
                            "&:last-of-type > td": {
                              border: "none",
                            },
                            "&:hover": {
                              background: "#80808021",
                            },
                            cursor: "pointer",
                          }}
                        >
                          <TableCell
                            onClick={() =>
                              handleToggle(
                                model.id,
                                model.projectId,
                                model.taskType,
                                model.trainingId ?? ""
                              )
                            }
                            sx={{
                              padding: "4px",
                              color: "#25213B",
                              fontSize: "14px",
                              fontWeight: "500",
                              maxWidth: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <abbr
                              title={model.trainingName}
                              style={{ textDecoration: "none" }}
                            >
                              {model.trainingName}
                            </abbr>
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleToggle(
                                model.id,
                                model.projectId,
                                model.taskType,
                                model.trainingId ?? ""
                              )
                            }
                            sx={{
                              padding: "4px",
                              color: "#25213B",
                              fontSize: "14px",
                              fontWeight: "500",
                              maxWidth: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <abbr
                              title={model.projectName}
                              style={{ textDecoration: "none" }}
                            >
                              {model.projectName}
                            </abbr>
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleToggle(
                                model.id,
                                model.projectId,
                                model.taskType,
                                model.trainingId ?? ""
                              )
                            }
                            sx={{
                              padding: "4px",
                              color: "#6E6893",
                              fontSize: "14px",
                              maxWidth: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <p
                              style={{
                                // background: "#CDFFCD",

                                padding: "3px 6px",
                                fontSize: "10px",
                                width: "fit-content",
                                margin: "3px 0",
                              }}
                            >
                              {model.status &&
                                ["success", "pending", "commencing"].includes(
                                  model.status.toLowerCase()
                                ) && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        backgroundColor: "#3498db",
                                        animation: "pulse 1s infinite",
                                      }}
                                    ></div>
                                    {model?.status.toLowerCase() !== "success"
                                      ? model?.status
                                      : ""}

                                    {(model?.progress ?? 0) > 0 && (
                                      <span>{model.progress ?? 0}%</span>
                                    )}
                                  </div>
                                )}
                              <span style={{ color: "red" }}>
                                {model.status &&
                                model?.status.toLowerCase() !== "success" &&
                                model?.status.toLowerCase() !== "completed" &&
                                model?.status.toLowerCase() !== "pending" &&
                                model?.status.toLowerCase() !== "commencing"
                                  ? model?.status
                                  : ""}
                              </span>
                            </p>
                            Started: {formatDate(model.dateTime)}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "4px",
                              color: "#25213B",
                              fontSize: "14px",
                            }}
                            onClick={() =>
                              handleToggle(
                                model.id,
                                model.projectId,
                                model.taskType,
                                model.trainingId ?? ""
                              )
                            }
                          >
                            {model.taskType}
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "4px",
                              color: "#25213B",
                              fontSize: "14px",
                              fontWeight: "500",
                              maxWidth: "100px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <abbr
                              //title={model.member}
                              style={{ textDecoration: "none" }}
                            >
                              {model.modelSize != null
                                ? `${Number(model.modelSize).toFixed(2)} MB`
                                : "0.00 MB"}
                            </abbr>
                          </TableCell>
                          <TableCell
                            id="modelMoreDetail"
                            sx={{
                              padding: "4px",
                              color: "#25213B",
                              fontSize: "14px",
                            }}
                          >
                            {/* New Button before MoreVert icon */}
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                textTransform: "none",
                                color: "#8B83BA",
                                borderColor: "#8B83BA",
                                fontSize: "12px",
                                marginRight: "8px",
                                padding: "2px 8px",
                              }}
                              disabled={model.isPublishedToAILabel}
                              onClick={() => handlePublishToAIAssist(model.id)}
                            >
                              Publish to AI Assist
                            </Button>

                            {/* <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                textTransform: "none",
                                color: "#8B83BA",
                                borderColor: "#8B83BA",
                                fontSize: "12px",
                                marginRight: "8px",
                                padding: "2px 8px",
                              }}
                              disabled={model.isPublishedToInferenceServer}
                              onClick={() => handlePublishToInference(model.id)}
                            >
                              Publish to Inference 
                            </Button> */}

                            <IconButton
                              size="small"
                              sx={{
                                color: "#8B83BA",
                                height: "20px",
                                width: "20px",
                              }}
                              onClick={(e) =>
                                handleMoreOptionClick(e, model.id)
                              }
                            >
                              <MoreVertOutlined sx={{ height: "16px" }} />
                            </IconButton>

                            <Menu
                              MenuListProps={{
                                "aria-labelledby": "long-button",
                              }}
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl)}
                              onClose={handleClose}
                              PaperProps={{
                                sx: {
                                  boxShadow: "none", // remove shadow
                                  border: "1px solid #e0e0e0", // light subtle border (Material gray)
                                  borderRadius: "8px", // optional: smooth corners
                                },
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  selectedModel &&
                                    handleModelRename(
                                      selectedModel.id,
                                      selectedModel.trainingName,
                                      selectedModel.projectId
                                    );
                                }}
                              >
                                <ListItemIcon>
                                  <ModeEditOutlineOutlined fontSize="small" />
                                </ListItemIcon>
                                Rename
                              </MenuItem>

                              {/* <MenuItem
                                onClick={() => {
                                  selectedModel &&
                                    handleDeleteModel(
                                      selectedModel.id,
                                      selectedModel.trainingName
                                    );
                                }}
                              >
                                <ListItemIcon>
                                  <DeleteOutline fontSize="small" />
                                </ListItemIcon>
                                Delete
                              </MenuItem> */}

                              <MenuItem
                                onClick={() => {
                                  const modelId = selectedModel?.trainingId;
                                  if (modelId) {
                                    handleDownload(modelId);
                                  }
                                }}
                                className={
                                  downloadingIds.includes(
                                    selectedModel?.trainingId || ""
                                  )
                                    ? "menu-item-downloading"
                                    : ""
                                }
                              >
                                <ListItemIcon>
                                  <FileDownloadOutlined fontSize="small" />
                                </ListItemIcon>
                                {downloadingIds.includes(
                                  selectedModel?.id || ""
                                )
                                  ? "Downloading"
                                  : "Download"}
                              </MenuItem>
                            </Menu>
                          </TableCell>
                        </TableRow>

                        {/* Accordion Row for Details */}
                        <TableRow sx={{ background: "#F0F7FF" }}>
                          <TableCell
                            colSpan={7}
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                            onClick={() =>
                              handleToggle(
                                model.id,
                                model.projectId,
                                model.taskType,
                                model.trainingId ?? ""
                              )
                            }
                          >
                            <Collapse
                              in={open === model.id}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box
                                sx={{
                                  margin: 1,
                                  height: "65vh",
                                  overflow: "scroll",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    gap: "20px",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 0, // no spacing between children
                                      flex: "0 0 25%",
                                    }}
                                  >
                                    <ConfusionMatrixIframe
                                      src={`${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${model.trainingId}&imgName=train_page_kpis.html`}
                                      scrolling="yes"
                                      height="500px"
                                      time=""
                                    />
                                    <ConfusionMatrixIframe
                                      src={`${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${model.trainingId}&imgName=labels.html`.replace(
                                        /\?t=\d+$/,
                                        ""
                                      )}
                                      scrolling="yes"
                                      height="400px"
                                      time=""
                                    />
                                  </Box>

                                  <Box
                                    sx={{
                                      background: "white",
                                      flexGrow: "1",
                                      alignContent: "center",
                                      borderRadius: "4px",
                                      width: "100%",
                                      position: "relative",
                                    }}
                                  >
                                    {/* <IconButton
                                      onClick={handleOpenConfusionMatrix}
                                      color="primary"
                                      sx={{
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        zIndex: 10,
                                      }}
                                    >
                                      <FullscreenIcon fontSize="large" />
                                    </IconButton> */}
                                    {(() => {
                                      if (
                                        (model.status &&
                                          model.status.toLowerCase() ===
                                            "failed") ||
                                        (model.status &&
                                          model.status.toLowerCase() ===
                                            "cancelled")
                                      ) {
                                        return (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "calc(100vh - 299px)",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: 150,
                                                height: 150,
                                                borderRadius: "50%",
                                                backgroundColor: "red",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                position: "relative",
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: 80,
                                                  fontWeight: "bold",
                                                  color: "white",
                                                  animation:
                                                    "shake 0.4s ease-in-out infinite",
                                                  "@keyframes shake": {
                                                    "0%": {
                                                      transform:
                                                        "translateX(0)",
                                                    },
                                                    "25%": {
                                                      transform:
                                                        "translateX(-5px)",
                                                    },
                                                    "50%": {
                                                      transform:
                                                        "translateX(5px)",
                                                    },
                                                    "75%": {
                                                      transform:
                                                        "translateX(-5px)",
                                                    },
                                                    "100%": {
                                                      transform:
                                                        "translateX(0)",
                                                    },
                                                  },
                                                }}
                                              >
                                                !
                                              </Typography>
                                            </Box>
                                            <Box
                                              sx={{
                                                textAlign: "center",
                                                marginTop: 0,
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: "20px",
                                                  color: "#000000",
                                                  fontWeight: "600",
                                                  marginTop: "20px",
                                                }}
                                              >
                                                Training failed!
                                              </Typography>
                                              <span
                                                style={{
                                                  color: "#0000003d",
                                                  fontSize: "15px",
                                                }}
                                              >
                                                Check errors & try again
                                              </span>
                                            </Box>
                                          </Box>
                                        );
                                      }

                                      if (
                                        (model.status &&
                                          model.status.toLowerCase() ===
                                            "running") ||
                                        (model.status &&
                                          model.status.toLowerCase() ===
                                            "pending") ||
                                        (model.status &&
                                          model.status.toLowerCase() ===
                                            "commencing") ||
                                        (model.status &&
                                          model.status.toLowerCase() ===
                                            "success")
                                      ) {
                                        return (
                                          <Box
                                            sx={{
                                              textAlign: "center",
                                              alignContent: "center",
                                            }}
                                          >
                                            <>
                                              {model.status.toLowerCase() ===
                                              "running" ? (
                                                <>
                                                  {model &&
                                                  Number(model?.progress) >=
                                                    90 ? (
                                                    <Box
                                                      sx={{
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "center",
                                                        alignContent: "center",
                                                        flexWrap: "wrap",
                                                        height:
                                                          "calc(100vh - 299px)",
                                                        background: "#fff",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <video
                                                        height="60"
                                                        loop
                                                        autoPlay
                                                        muted
                                                      >
                                                        <source
                                                          src={dataProcess}
                                                          type="video/mp4"
                                                        />
                                                        Your browser does not
                                                        support the video tag.
                                                      </video>
                                                      <Box
                                                        sx={{ width: "100%" }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            fontSize: "20px",
                                                            color: "#000000",
                                                            fontWeight: "600",
                                                          }}
                                                        >
                                                          Data to Intelligence
                                                        </Typography>
                                                        <span
                                                          style={{
                                                            color: "#0000003d",
                                                            fontSize: "15px",
                                                          }}
                                                        >
                                                          Complex algorithms at
                                                          work. Progress looks
                                                          good!
                                                        </span>
                                                      </Box>
                                                    </Box>
                                                  ) : (
                                                    <Box
                                                      sx={{
                                                        display: "grid",
                                                        gap: "10px",
                                                        gridTemplateColumns:
                                                          "repeat(1, 1fr)",
                                                        // paddingBottom:
                                                        //   "140px",
                                                      }}
                                                    >
                                                      <Card
                                                        sx={{
                                                          padding: "15px",
                                                          // background: "#FAFAFB",
                                                          boxShadow: "none",
                                                        }}
                                                      >
                                                        <CardContent
                                                          sx={{
                                                            padding: "0",
                                                            paddingBottom:
                                                              "0 !important",
                                                          }}
                                                        >
                                                          <iframe
                                                            src={`${process.env.REACT_APP_TESTING_GRAPHS}/VisionStudio/LivePlot1?TrainingId=${model.trainingId}`}
                                                            height="456px"
                                                            width="100%"
                                                            scrolling="no"
                                                            style={{
                                                              border: "none",
                                                            }}
                                                          />
                                                        </CardContent>
                                                      </Card>

                                                      <Card
                                                        sx={{
                                                          padding: "15px",
                                                          // background: "#FAFAFB",
                                                          boxShadow: "none",
                                                        }}
                                                      >
                                                        <CardContent
                                                          sx={{
                                                            padding: "0",
                                                            paddingBottom:
                                                              "0 !important",
                                                          }}
                                                        >
                                                          <iframe
                                                            src={`${process.env.REACT_APP_TESTING_GRAPHS}/VisionStudio/LivePlot2?TrainingId=${model.trainingId}`}
                                                            height="456px"
                                                            width="100%"
                                                            scrolling="no"
                                                            style={{
                                                              border: "none",
                                                            }}
                                                          />
                                                        </CardContent>
                                                      </Card>
                                                      <Card
                                                        sx={{
                                                          padding: "15px",
                                                          // background: "#FAFAFB",
                                                          boxShadow: "none",
                                                        }}
                                                      >
                                                        <CardContent
                                                          sx={{
                                                            padding: "0",
                                                            paddingBottom:
                                                              "0 !important",
                                                          }}
                                                        >
                                                          <AuthenticatedReportImage
                                                            src={`${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${model.trainingId}&imgName=samples.webp`.replace(
                                                              /\?t=\d+$/,
                                                              ""
                                                            )}
                                                            height="456px"
                                                            width="100%"
                                                          />
                                                        </CardContent>
                                                      </Card>
                                                    </Box>
                                                  )}
                                                </>
                                              ) : model.status.toLowerCase() ===
                                                "success" ? (
                                                <Box
                                                  sx={{
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    alignContent: "center",
                                                    flexWrap: "wrap",
                                                    height:
                                                      "calc(100vh - 299px)",
                                                    background: "#fff",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <video
                                                    height="80"
                                                    loop
                                                    autoPlay
                                                    muted
                                                  >
                                                    <source
                                                      src={crunching}
                                                      type="video/mp4"
                                                    />
                                                    Your browser does not
                                                    support the video tag.
                                                  </video>
                                                  <Box sx={{ width: "100%" }}>
                                                    <Typography
                                                      sx={{
                                                        fontSize: "20px",
                                                        color: "#000000",
                                                        fontWeight: "600",
                                                      }}
                                                    >
                                                      Crunching Data...
                                                    </Typography>
                                                    <span
                                                      style={{
                                                        color: "#0000003d",
                                                        fontSize: "15px",
                                                      }}
                                                    >
                                                      Initializing the training
                                                      process. Let’s get those
                                                      neurons firing!
                                                    </span>
                                                  </Box>
                                                </Box>
                                              ) : model.status.toLowerCase() ===
                                                  "commencing" ||
                                                model.status.toLowerCase() ===
                                                  "pending" ? (
                                                <Box
                                                  sx={{
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    alignContent: "center",
                                                    flexWrap: "wrap",
                                                    height:
                                                      "calc(100vh - 299px)",
                                                    background: "#fff",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <video
                                                    width="150"
                                                    loop
                                                    autoPlay
                                                    muted
                                                  >
                                                    <source
                                                      src={finalResult}
                                                      type="video/mp4"
                                                    />
                                                    Your browser does not
                                                    support the video tag.
                                                  </video>
                                                  <Box sx={{ width: "100%" }}>
                                                    <Typography
                                                      sx={{
                                                        fontSize: "20px",
                                                        color: "#000000",
                                                        fontWeight: "600",
                                                      }}
                                                    >
                                                      Final stretch
                                                    </Typography>
                                                    <span
                                                      style={{
                                                        color: "#0000003d",
                                                        fontSize: "15px",
                                                      }}
                                                    >
                                                      Your AI has reached its
                                                      peak. Let’s take it live!
                                                    </span>
                                                  </Box>
                                                </Box>
                                              ) : (
                                                "There is no result for this model."
                                              )}
                                            </>
                                          </Box>
                                        );
                                      }

                                      return null;
                                    })()}
                                    {model.status &&
                                    model.status.toLowerCase() ===
                                      "completed" ? (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "10px",
                                          width: "100%",
                                        }}
                                      >
                                        <Card
                                          sx={{
                                            padding: "15px",
                                            boxShadow: "none",
                                          }}
                                        >
                                          <CardContent
                                            sx={{
                                              padding: 0,
                                              paddingBottom: "0 !important",
                                            }}
                                          >
                                            <ConfusionMatrixIframe
                                              src={`${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${model.trainingId}&imgName=graph_2.html`.replace(
                                                /\?t=\d+$/,
                                                ""
                                              )}
                                              height="509px"
                                              scrolling="yes"
                                              time={""}
                                            />
                                          </CardContent>
                                        </Card>

                                        <Card
                                          sx={{
                                            padding: "15px",
                                            boxShadow: "none",
                                          }}
                                        >
                                          <CardContent
                                            sx={{
                                              padding: 0,
                                              paddingBottom: "0 !important",
                                            }}
                                          >
                                            <ConfusionMatrixIframe
                                              src={`${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${model.trainingId}&imgName=graph_1.html`.replace(
                                                /\?t=\d+$/,
                                                ""
                                              )}
                                              height="500px"
                                              scrolling="yes"
                                              time={""}
                                            />
                                          </CardContent>
                                        </Card>

                                        <Box
                                          sx={{
                                            display: "grid",
                                            gap: "10px",
                                            gridTemplateColumns:
                                              "repeat(2, 1fr)",
                                          }}
                                        >
                                          <Card
                                            sx={{
                                              padding: "15px",
                                              boxShadow: "none",
                                            }}
                                          >
                                            <CardContent
                                              sx={{
                                                padding: 0,
                                                paddingBottom: "0 !important",
                                              }}
                                            >
                                              <Typography
                                                gutterBottom
                                                variant="h5"
                                                component="div"
                                              >
                                                Comparison
                                              </Typography>
                                              <AuthenticatedReportImage
                                                src={`${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${model.trainingId}&imgName=results_comparison.webp`.replace(
                                                  /\?t=\d+$/,
                                                  ""
                                                )}
                                                height="456px"
                                                width="100%"
                                              />
                                            </CardContent>
                                          </Card>

                                          <Card
                                            sx={{
                                              padding: "15px",
                                              boxShadow: "none",
                                            }}
                                          >
                                            <CardContent
                                              sx={{
                                                padding: 0,
                                                paddingBottom: "0 !important",
                                              }}
                                            >
                                              <Typography
                                                gutterBottom
                                                variant="h5"
                                                component="div"
                                              >
                                                Confusion Matrix
                                              </Typography>
                                              <ConfusionMatrixIframe
                                                src={`${process.env.REACT_APP_SERVER_BASEURL}/api/ProjectTrain/DownloadCMReport?trainingId=${model.trainingId}&imgName=confusion_matrix.html`.replace(
                                                  /\?t=\d+$/,
                                                  ""
                                                )}
                                                height="500px"
                                                scrolling="yes"
                                                time={""}
                                              />
                                            </CardContent>
                                          </Card>
                                        </Box>
                                      </Box>
                                    ) : null}
                                  </Box>
                                </Box>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                  ) : (
                    <TableCell colSpan={7} sx={{ border: 0 }}>
                      <p style={{ textAlign: "center", fontSize: "18px" }}>
                        All your models will reside here
                      </p>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
        <div>
          <Dialog
            open={openDeleteModal}
            onClose={handleCloseDeleteModal}
            aria-labelledby="delete-confirmation-dialog"
            aria-describedby="delete-confirmation-description"
            PaperProps={{
              style: {
                boxShadow: "none",
                width: "50%",
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: "#2121210f",
                },
              },
            }}
            BackdropProps={{
              style: {
                opacity: 0.3,
              },
            }}
          >
            <DialogTitle id="delete-confirmation-dialog">
              Delete Model
            </DialogTitle>
            <DialogContent sx={{ paddingBottom: "0" }}>
              <p>
                Are you sure you want to delete the model{" "}
                <strong>"{currentName}"</strong>?
              </p>
            </DialogContent>
            <DialogActions>
              <Button
                id="calcelDeleteModel"
                onClick={handleCloseDeleteModal}
                variant="outlined" // color="primary"
              >
                Cancel
              </Button>
              <Button
                id="confirmDeleteModel"
                onClick={handleConfirmDelete}
                variant="contained" // color="secondary"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openEditModelModal}
            onClose={handleRenameModelClose}
            aria-labelledby="rename-model-dialog"
            aria-describedby="rename-model-description"
            PaperProps={{
              style: {
                boxShadow: "none",
                width: "100%",
              },
            }}
            slotProps={{
              backdrop: {
                sx: {
                  backgroundColor: "#2121210f",
                },
              },
            }}
            BackdropProps={{
              style: {
                opacity: 0.3,
              },
            }}
          >
            <DialogTitle id="rename-model-dialog">Rename Model</DialogTitle>
            <DialogContent
              sx={{
                paddingBottom: "5px",
                paddingTop: "5px!important",
              }}
            >
              <TextField
                sx={{ width: "100%", padding: "0px" }}
                id="modelName"
                label="Model Name"
                defaultValue={currentName}
                size="small"
                onChange={handleChange}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleRenameModelClose}
                variant="outlined" // color="primary"
              >
                Cancel
              </Button>
              <Button
                onClick={handleRenameModelSave}
                variant="contained" // color="secondary"
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Box>
      <Dialog
        open={openConfusionMatrix}
        onClose={handleCloseConfusionMatrix}
        fullScreen
        sx={{
          "& .MuiPaper-root": {
            height: "100vh", // Full height
            background: "#00000030", // Dark overlay effect
            backdropFilter: "blur(5px)", // Blur effect
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* Close Button on Top-Right */}
        <IconButton
          onClick={handleCloseConfusionMatrix}
          sx={{
            position: "absolute",
            top: 37,
            right: 24,
            color: "white",
            zIndex: 10,
            background: "#000",
            "&:hover": {
              background: "#333", // Change to desired hover background color
            },
          }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>

        {/* Content */}
        <DialogContent sx={{ flex: 1, overflow: "auto" }}>
          <ConfusionMatrix
            statusCMImg={statusCMImg}
            statusRImg={statusRImg}
            statusPCImg={statusPCImg}
            statusRCImg={statusRCImg}
            LoaderGIF={LoaderGIF}
            modelType={modelType}
            currentConfusisonMetrixPNG={currentConfusisonMetrixPNG}
            currentResultPNG={currentResultPNG}
            currentPCurvePNG={currentPCurvePNG}
            currentRCurvePNG={currentRCurvePNG}
            boxHeight={"100"}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default withSpinner(Model);
